export var DEFAULT_NAMESPACE = '/';
export var ACTION_TYPE_DELIMITER = '||';


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/constants.js
// module id = Hize
// module chunks = 0